import { notification } from 'antd';

export const ErrorHandler = async (error) => {
    const { response = { data: { message: "Something Went Wrong" } } } = error;
    const { data } = response;
    await notification['error']({ message: "Fail", description: data.message, key: "error" })

}